import React, { useState, useEffect } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ReactRouterPropTypes from 'react-router-prop-types';
import { showNotificationAutoDestroy } from '../../../shared/components/ShowNotification';
import {
  changeLoadingTrue,
  changeLoadingFalse,
} from '../../../redux/actions/loadingActions';
import {
  schoolTermFindByIdQuery,
  saveSchoolTermMutation,
} from '../../../shared/queries/SchoolTerm';
import GraphQL from '../../../GraphQL';
import SchoolTermForm from './Form';
import SmartCard from '../../../shared/components/SmartCard';

const SchoolTermFormHandler = (props) => {
  const { match, t, history, dispatch } = props;
  const [dto, setDto] = useState({ id: 0 });
  const [formOn, setFormOn] = useState(false);
  const listOfStatus = [
    { value: 'L', label: t('school-term.L') },
    { value: 'F', label: t('school-term.F') },
  ];

  function backClickHandler() {
    history.push('/minime/periodo-letivo');
  }

  function showLoading() {
    dispatch(changeLoadingTrue());
  }

  function hideLoading() {
    dispatch(changeLoadingFalse());
  }

  function findById(id) {
    showLoading();
    const query = schoolTermFindByIdQuery(id);
    GraphQL(query, {})
      .then((res) => {
        if (res.schoolTermFindById) {
          setDto({
            ...res.schoolTermFindById,
            initialDate: new Date(res.schoolTermFindById.initialDate),
            finalDate: new Date(res.schoolTermFindById.finalDate),
            year: new Date(res.schoolTermFindById.year, 1, 1),
            status: {
              value: res.schoolTermFindById.status,
              label: t(`school-term.${res.schoolTermFindById.status}`),
            },
          });
        } else {
          showNotificationAutoDestroy(
            'danger',
            t('notifications.error'),
            t('notifications.record-not-found')
          );
          backClickHandler();
        }
      })
      .catch(() => {
        showNotificationAutoDestroy(
          'danger',
          t('notifications.error'),
          t('notifications.find-record-error')
        );
      })
      .finally(() => {
        hideLoading();
      });
  }

  const handleSubmit = (values) => {
    const mutation = saveSchoolTermMutation(values);
    showLoading();
    GraphQL(mutation, {})
      .then(() => {
        backClickHandler();
        showNotificationAutoDestroy(
          'success',
          t('success.title'),
          t('success.successfully-saved')
        );
      })
      .catch(() => {
        showNotificationAutoDestroy(
          'danger',
          t('notifications.error'),
          t('errors.error-to-save')
        );
      })
      .finally(() => {
        hideLoading();
      });
  };

  useEffect(() => {
    if (match.params.id && match.params.id > 0) {
      if (dto.id !== parseInt(match.params.id, 0)) {
        findById(match.params.id);
      } else {
        setFormOn(true);
      }
    } else {
      setFormOn(true);
    }
  }, [dto]);

  return (
    <SmartCard title={t('panels.periodo-letivo')}>
      {formOn ? (
        <SchoolTermForm
          onSubmit={handleSubmit}
          backHandler={backClickHandler}
          dto={dto}
          status={listOfStatus}
        />
      ) : null}
    </SmartCard>
  );
};

SchoolTermFormHandler.propTypes = {
  t: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  history: ReactRouterPropTypes.history.isRequired,
  match: ReactRouterPropTypes.match.isRequired,
};

export default withTranslation('common')(
  connect((state) => ({
    loading: state.loading,
  }))(SchoolTermFormHandler)
);
